<template>
  <moon-loader color="#2D9CDB" :size="size" v-if="ready"></moon-loader>
</template>

<script>
  import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

  export default {
    components: {
      MoonLoader
    },
    data() {
      return {
        color: '#2D9CDB',
        size: '20',
        ready: false
      }
    },
    beforeMount() {
      if (this.$el.dataset.size) {
        this.size = this.$el.dataset.size + 'px'
      }
  },
    mounted() {
      this.ready = true
    }
  }
</script>
